import { render, staticRenderFns } from "./team-members.vue?vue&type=template&id=0c0add10&scoped=true"
import script from "./team-members.vue?vue&type=script&lang=js"
export * from "./team-members.vue?vue&type=script&lang=js"
import style0 from "./team-members.vue?vue&type=style&index=0&id=0c0add10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0add10",
  null
  
)

export default component.exports